"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageMGSC = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var layout_1 = require("./shared/layout");
var mini_time_chart_1 = require("./shared/mini_time_chart");
var mini_k_chart_1 = require("./shared/mini_k_chart");
var title_bar_1 = require("./shared/title_bar");
var zixun_1 = require("./shared/zixun");
var title_quotetable_1 = require("./shared/title/title_quotetable");
var utils_1 = require("../../modules/utils");
var swr_1 = __importDefault(require("swr"));
/**
 * 美股市场-首页
 * @returns
 */
function PageMGSC() {
    return (react_1.default.createElement("div", { className: "pagemgsc" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(layout_1.Layout3, { mt: 5 },
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "100.DJIA", height: 180, width: 326, link: true, border: false, more: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(XXDZ, null)) }, "\u9053\u743C\u65AF\u6307\u6570"),
                react_1.default.createElement("div", { style: { marginTop: 15 } },
                    react_1.default.createElement(mini_k_chart_1.MiniKChart, { width: 326, quotecode: "100.DJIA" }))),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "100.NDX", height: 180, width: 326, link: true, border: false }, "\u7EB3\u65AF\u8FBE\u514B\u6307\u6570"),
                react_1.default.createElement("div", { style: { marginTop: 15 } },
                    react_1.default.createElement(mini_k_chart_1.MiniKChart, { width: 326, quotecode: "100.NDX" }))),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "100.SPX", height: 180, width: 326, link: true, border: false }, "\u6807\u666E500\u6307\u6570"),
                react_1.default.createElement("div", { style: { marginTop: 15 } },
                    react_1.default.createElement(mini_k_chart_1.MiniKChart, { width: 326, quotecode: "100.SPX" })))),
        react_1.default.createElement(title_bar_1.TitleBar, { mt: 15 },
            react_1.default.createElement(title_bar_1.TitleBar.Title, null,
                react_1.default.createElement("a", { href: "//stock.eastmoney.com/a/cmgdd.html" }, "\u7F8E\u80A1\u5BFC\u8BFB")),
            react_1.default.createElement(title_bar_1.TitleBar.Content, null,
                react_1.default.createElement(zixun_1.ColumnNewsScroll, { columns: "768" }))),
        react_1.default.createElement(layout_1.Layout2, { mt: 7 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(MGChildTable, { tbkey: "MGSCZFB", fs: "b:MK0001", tit: "\u77E5\u540D\u7F8E\u80A1\u6DA8\u5E45\u699C", link: "gridlist.html#us_wellknown", orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u77E5\u540D\u7F8E\u80A1\u6DA8\u5E45\u699C" })),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(MGChildTable, { tbkey: "MGSCZFB", fs: "b:MK0001", tit: "\u77E5\u540D\u7F8E\u80A1\u8DCC\u5E45\u699C", link: "gridlist.html?sr=0#us_wellknown", orderdur: 0, bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u77E5\u540D\u7F8E\u80A1\u8DCC\u5E45\u699C" }))),
        react_1.default.createElement(layout_1.Layout2, { mt: 20 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(MGChildTable, { tbkey: "MGSCZFB", fs: "b:MK0201", tit: "\u4E2D\u6982\u80A1\u6DA8\u5E45\u699C", link: "gridlist.html#us_chinese", orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u4E2D\u6982\u80A1\u6DA8\u5E45\u699C" })),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(MGChildTable, { tbkey: "MGSCZFB", fs: "b:MK0201", tit: "\u4E2D\u6982\u80A1\u8DCC\u5E45\u699C", link: "gridlist.html?sr=0#us_chinese", orderdur: 0, bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u4E2D\u6982\u80A1\u8DCC\u5E45\u699C" }))),
        react_1.default.createElement(layout_1.Layout4, { mt: 10 },
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(MGChildTable, { tbkey: "CommonChangePercent", fs: "m:105,m:106,m:107", tit: "\u5168\u90E8\u7F8E\u80A1\u6DA8\u5E45", link: "gridlist.html#us_stocks", orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u66F4\u591A", topmore: false })),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(MGChildTable, { tbkey: "CommonChangePercent", fs: "b:MK0202", tit: "\u4E92\u8054\u7F51\u4E2D\u56FD\u6DA8\u5E45", link: "gridlist.html#us_chinese_internet", orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u66F4\u591A", topmore: false })),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(MGChildTable, { tbkey: "CommonChangePercent", fs: "b:MK0216", tit: "\u79D1\u6280\u7C7B\u6DA8\u5E45", link: "gridlist.html#us_technology", orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u66F4\u591A", topmore: false })),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(MGChildTable, { tbkey: "CommonChangePercent", fs: "b:MK0217", tit: "\u91D1\u878D\u7C7B\u6DA8\u5E45", link: "gridlist.html#us_financial", orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u66F4\u591A", topmore: false }))),
        react_1.default.createElement(layout_1.Layout4, { mt: 7 },
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(MGChildTable, { tbkey: "CommonChangePercent", fs: "b:MK0218", tit: "\u533B\u836F\u98DF\u54C1\u7C7B\u6DA8\u5E45", link: "gridlist.html#us_medicine_food", orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u66F4\u591A", topmore: false })),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(MGChildTable, { tbkey: "CommonChangePercent", fs: "b:MK0220", tit: "\u5A92\u4F53\u7C7B\u6DA8\u5E45", link: "gridlist.html#us_media", orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u66F4\u591A", topmore: false })),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(MGChildTable, { tbkey: "CommonChangePercent", fs: "b:MK0219", tit: "\u6C7D\u8F66\u80FD\u6E90\u7C7B\u6DA8\u5E45", link: "gridlist.html#us_automotive_energy", orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u66F4\u591A", topmore: false })),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(MGChildTable, { tbkey: "CommonChangePercent", fs: "b:MK0221", tit: "\u5236\u9020\u96F6\u552E\u7C7B", link: "gridlist.html#us_manufacture_retail", orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u66F4\u591A", topmore: false })))));
}
exports.PageMGSC = PageMGSC;
/**
 * 美股小tables
 * @param props
 * @returns
 */
function MGChildTable(props) {
    var _a;
    var more = (_a = props.topmore) !== null && _a !== void 0 ? _a : true;
    return (react_1.default.createElement(title_quotetable_1.Title1QuoteTable, { more: more ? react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: props.link }, "\u66F4\u591A>>")) : react_1.default.createElement(react_1.default.Fragment, null), bottom_more: react_1.default.createElement("a", { href: props.link },
            props.bmtxt,
            ">>"), table_key: props.tbkey,
        fs: props.fs,
        count: 5,
        order: 'f3',
        orderdur: props.orderdur },
        react_1.default.createElement("a", { href: props.link, target: "_blank" }, props.tit)));
}
/**
 * 小型道指当月连续
 */
function XXDZ() {
    var _this = this;
    var data = (0, swr_1.default)('103_YM00Y_qt', function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        url: "//futsseapi.eastmoney.com/static/103_YM00Y_qt?callbackName=zz",
                        scriptCharset: "utf-8",
                        dataType: "jsonp",
                        jsonp: "cb",
                        jsonpCallback: 'zz',
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, {
        refreshInterval: 30 * 1000
    }).data;
    if (!data || !data.qt) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var qt = data.qt, color = (0, utils_1.getColor)(qt.zde);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "hot_xxdz" },
            react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(qt.sc, ".").concat(qt.dm), target: "_blank" }, qt.name),
            "\u00A0",
            react_1.default.createElement("span", { className: color }, (0, utils_1.formatNum)(qt.p, qt.zsjd, '')),
            "\u00A0",
            react_1.default.createElement("span", { className: color }, (0, utils_1.formatNum)(qt.zdf, 2, '%')))));
}
